'use strict';
// https://github.com/tc39/proposal-array-grouping
require('../modules/esnext.array.group');
require('../modules/esnext.array.group-to-map');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/array-grouping-stage-3-2.js
// module id = 1043
// module chunks = 29